import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const generalApiService = createApi({
  reducerPath: 'generalApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/general/'),
  endpoints: (builder) => ({
    getGeneral: builder.query({
      query: () => 'get',
      keepUnusedDataFor: 0
    }),
    getDashboard: builder.query({
      query: () => 'dashboard',
      keepUnusedDataFor: 0
    }),
    uploadImage: builder.mutation({
      query: (args) => ({
        url: 'upload-image',
        method: 'POST',
        body: args
      })
    })
  })
})

export const {
  useGetGeneralQuery,
  useLazyGetGeneralQuery,
  useGetDashboardQuery,
  useUploadImageMutation
} = generalApiService